import styled from 'styled-components';

export const Wrapper = styled.div`
width: 100%;
box-sizing: border-box;
`;

export const Container = styled.div`
width: 100%;
box-sizing: border-box;
display: flex;
flex-flow: column wrap;
align-items: flex-start;
justify-content: flex-start;
`;

export const BreadCrumbSection = styled.div`
width: 100%;
box-sizing: border-box;
margin-bottom: 26px;
`;

export const Section = styled.div`
width: 100%;
box-sizing: border-box;
display: flex;
flex-flow: column wrap;
align-items: flex-start;
justify-content:flex-start;
background-color: #ffffff;
box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.12);
border-radius: 8px;
margin-bottom: 24px;
`;

export const SectionTitle = styled.div`
width: 100%;
box-sizing: border-box;
font-weight: 600;
font-size: 18px;
line-height: 27px;
padding: 30px;
border-bottom: 1px solid #E9EDF5;
color: #000000;
`;

export const SectionBody = styled.div`
width: 100%;
box-sizing: border-box;
padding: 30px;
display: flex;
flex-flow: column;
align-items: flex-start;
justify-content: flex-start;
`;

export const FormBody = styled.div`
width: 100%;
box-sizing: border-box;
display: flex;
flex-flow: row nowrap;
align-items: flex-start;
justify-content: flex-start;
column-gap: 50px;
`;

export const TwoSectonView = styled.div`
display: flex;
flex-flow: column;
flex-basis: 50%;
`;

export const AuctionView = styled.div`
width: 100%;
box-sizing: border-box;
margin-top: 20px;
`;